import { render, staticRenderFns } from "./privacyAbstract.vue?vue&type=template&id=f3ab51b0"
import script from "./privacyAbstract.vue?vue&type=script&lang=js"
export * from "./privacyAbstract.vue?vue&type=script&lang=js"
import style0 from "./privacyAbstract.vue?vue&type=style&index=0&id=f3ab51b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports